export const calendarConfig = {
  username: 'guillaume-br-7smp67',
  settings: {
    layout: 'month_view',
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    theme: 'light'
  }
};